import ModuleWrapper from '@/components/page/ModuleWrapper';

const LiveOffers = () => import(/* webpackChunkName: "live-offers-default" */ '@/views/LiveOffers/LiveOffers');
const LivePendingOfferDetails = () => import(/* webpackChunkName: "live-offer-details" */ '@/views/LiveOfferDetails/LivePendingOfferDetails');
const meta = (data = {}) => ({
    moduleName: 'liveOffers',
    auth: true,
    ...data,
});

export default [{
    path: 'live-offers',
    component: ModuleWrapper,
    meta: meta({
        title: 'Live Offers',
    }),
    children: [
        {
            path: '',
            name: 'LiveOffers',
            props: true,
            component: LiveOffers,
            meta: meta({}),
        },
        {
            path: ':id(\\d+)/:type',
            name: 'LivePendingOfferDetails',
            props: true,
            component: LivePendingOfferDetails,
            meta: meta({}),
        },
    ],
}];
